<script lang="ts" setup>
import InlineSvg from 'vue-inline-svg'
import icons from '@/assets/icons'
import type { Icons } from '@/types/icons'

interface Props {
    icon: Icons
}

defineProps<Props>()
</script>

<template>
    <InlineSvg :src="icons[icon]" />
</template>
